import React, { useEffect, useRef } from "react";
import "react-h5-audio-player/lib/styles.css";

const RadioPlayer = ({ src, title, img }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.load();
      audio.play().catch((e) => console.error("Error al reproducir:", e));
    }
  }, [src]);

  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-3 p-4">
      <img
        src={img}
        className="w-24 h-24 md:w-36 md:h-36 rounded-md"
        alt="imagen_radio"
      />
      <div className="flex flex-col gap-3 items-center md:items-start text-center md:text-left">
        <p className="text-lg md:text-2xl">{title}</p>
        <audio
          ref={audioRef}
          autoPlay
          controls
          className="w-[250px]  rounded-md "
        >
          <source src={src} type="audio/mp3" />
        </audio>
      </div>
    </div>
  );
};

export default RadioPlayer;
